import type { FC } from 'react';
import { cn } from '@/app/utils';

interface CompactTaskHistoryLoginGuideProps {
  label: string;
  className?: string;
}

export const CompactTaskHistoryLoginGuide: FC<CompactTaskHistoryLoginGuideProps> = ({ label, className }) => (
  <div
    className={cn(
      'flex h-full min-h-20 w-full items-center justify-center rounded-10 px-2 text-center text-system-white48 text-xs',
      className,
    )}
  >
    {label}
  </div>
);
